export default __webpack_public_path__ + "static/media/oceania_exam.50517f0b.png";